// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"516":"css/admin-app.7094","3330":"css/app.7094"}[chunkId] + ".css";
};